<template>
  <div class="answer-sheet">
    <div class="answer-sheet-title">
      <div class="txt">答题卡</div>
      <!-- <div class="redo">
        <img class="icon-delete" src="../../assets/images/icons/icon-delete.png" />
        <div class="redo-txt">重做</div>
      </div> -->
    </div>
    <div class="answer-sheet-list">
      <div class="title"  v-if="radioList.length > 0">单选题</div>
      <div class="list-card">
        <div 
          v-for="item in radioList" 
          :key="item.index" 
          @click="$store.dispatch('questions/selectQuestion', {type: 'card', index: item.index})"  
          :class="['number', item.isAnswer === 1 ? 'right' : item.isAnswer === 0 ? 'error' : item.isAnswer === 3 ? 'hased' : '' ]">
          {{item.index}}
        </div>
      </div>
      <div class="title" v-if="checkList.length > 0">多选题</div>
      <div class="list-card">
        <div 
          v-for="item in checkList" 
          :key="item.index" 
          @click="$store.dispatch('questions/selectQuestion', {type: 'card', index: item.index})" 
          :class="['number', item.isAnswer === 1 ? 'right' : item.isAnswer === 0 ? 'error' : item.isAnswer === 3 ? 'hased' : '' ]">
          {{item.index}}
        </div>
      </div>
      <div class="title" v-if="judgeList.length > 0">判断题</div>
      <div class="list-card">
        <div 
          v-for="item in judgeList" 
          :key="item.index" 
          @click="$store.dispatch('questions/selectQuestion', {type: 'card', index: item.index})" 
          :class="['number', item.isAnswer === 1 ? 'right' : item.isAnswer === 0 ? 'error' : item.isAnswer === 3 ? 'hased' : '' ]">
          {{item.index}}
        </div>
      </div>
      <!-- <div class="title">问答题</div>
      <div class="list-card">
        <div v-for="item in 6" class="number error">{{42 + item}}</div>
      </div>
      <div class="title">问答题</div>
      <div class="list-card">
        <div v-for="item in 6" class="number no-do">{{42 + item}}</div>
      </div> -->
    </div>
    <div class="analysis-result">
      <div class="box">
        <div class="label error"></div>
        <div class="txt">错误 {{wrongNum}}</div>
      </div>
      <div class="box">
        <div class="label right"></div>
        <div class="txt">正确 {{rightNum}}</div>
      </div>
      <!-- <div class="box">
        <div class="label no-done"></div>
        <div class="txt">未做 2</div>
      </div> -->
    </div>
    <el-button v-if="finished === 1" class="btn-save" type="primary" @click="$store.dispatch('questions/findScore', Object.assign({}, params, { submissionId: submissionId}))">查看成绩</el-button>
    <el-button v-else class="btn-save" :disabled="isAnswer" type="primary" @click="submit">提交试卷</el-button>
  </div>
</template>

<script>

  export default {
    name: 'HelloWorld',
    data () {
      return {
        isAnswer : true,
        answers: {},
        params: this.$route.query,
        stuId: this.$route.query.stuId
      }
    },
    watch: {
      '$store.state.questions.answers': {
        deep: true,
        handler: function (newValue, oldValue) {
          this.radioList.forEach(item => {
            if(newValue[item.id]) {
              item.isAnswer = 3;
            }else {
              item.isAnswer = 4;
            }
          });
          this.checkList.forEach(item => {
            if(newValue[item.id]) {
              item.isAnswer = 3;
            }else {
              item.isAnswer = 4;
            }
          });
          this.judgeList.forEach(item => {
            if(newValue[item.id]) {
              item.isAnswer = 3;
            }else {
              item.isAnswer = 4;
            }
          });
          let currentNum = Object.keys(newValue).length;
          if(this.totalNumber == currentNum) {
            this.isAnswer = false;
          }else {
            this.isAnswer = true;
          }
          this.answers = newValue;
        }
      }
    },
    computed: {
      radioList() {
        return this.$store.state.questions.radioList;
      },
      checkList() {
        return this.$store.state.questions.checkList;
      },
      judgeList() {
        return this.$store.state.questions.judgeList;
      },
      totalNumber() {
        return this.$store.state.questions.questionNum;
      },
      submissionId() {
        return this.$store.state.questions.submissionId;
      },
      finished() {
        return this.$store.state.questions.finished;
      },
      rightNum() {
        return this.$store.state.questions.rightNum;
      },
      wrongNum() {
        return this.$store.state.questions.wrongNum;
      }
    },
    methods: {
      submit() {
        let params = {
          stuId: this.stuId,
          courseType: this.$route.query.courseType
        }
        let arr = Object.keys(this.answers);
        let answers = arr.map(item => (
          {
            id: this.answers[item].id,
            answer: this.answers[item].answer
          }
        ))
        params.answer = JSON.stringify( answers );
        this.$store.dispatch('questions/submitQuestion', params)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/style.scss';
  .answer-sheet {
    width: 280px;
    height: 450px;
    background: #fff;
    position: relative;

    .answer-sheet-title {
      margin: 0 20px;
      padding: 18px 0;
      border-bottom: 1px solid #F0F0F0;
      @include flex-vertical-center();
      .txt {
        padding-left: 12px;
        margin-right: 5px;
        font-size: 18px;
        color: $answer-text-primary;
        position: relative;
        
        &::before {
          content: '';
          display: block;

          width: 4px;
          height: 20px;
          background: $answer-primary;

          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .redo {
        width: 59px;
        height: 22px;
        border-radius: 11px;
        background: #F2F2F2;
        cursor: pointer;
        @include flex-vertical-center();

        .icon-delete {
          width: 14px;
          height: 14px;
          margin: 0 3px 0 7px;
        }
        .redo-txt {
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
      }
    }

    .answer-sheet-list {
      height: 266px;
      overflow-x: auto;
      margin: 0 20px;

      .title {
        padding: 20px 0 15px;
        font-size: 14px;
        color: #333;
      }

      .list-card {
        // max-height: 110px;
        // overflow-y: auto;
        @include flex-wrap();

        .number {
          width: 28px;
          height: 28px;
          margin: 0 10px 12px 0;

          border-radius: 2px;
          border: 1px solid #E8E8E8;
          cursor: pointer;

          font-size: 14px;
          color: #333;
          text-align: center;
          line-height: 28px;

          &.right, &.hased, &.error, &.no-do {
            color: #fff;
            border: 0;
          }

          &.right {
            background: $answer-sheet-right;
          }

          &.hased {
            background: $answer-primary;
          }

          &.error {
            background: $answer-sheet-error;
          }

          &.no-do {
            background: $answer-no-do;
          }
        }
      }
    }

    .analysis-result {
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: 85px;
      transform: translateX(-50%);
      @include flex-vertical-center();

      .box {
        margin-right: 12px;
        @include flex-vertical-center();

        &:first-child {
          margin-left: 30px;
        }

        .label {
          width: 16px;
          height: 16px;
          margin-right: 2px;
          border-radius: 2px;

          &.error {
            background-color: $answer-sheet-error;
          }

          &.right {
            background-color: $answer-sheet-right;
          }

          &.no-done {
            border: 1px solid #E8E8E8;
          }
        }

        .txt {
          font-size: 14px;
          color: #666;
        }
      }
    }

    .btn-save {
      width: 260px;
      height: 45px;
      padding: 0;

      border-radius: 4px;
      // background-color: $answer-primary;

      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 45px;

      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
    }
  }

  /*修改滚动条样式*/
  div::-webkit-scrollbar{
    width:10px;
    height:10px;
    /**/
  }
  div::-webkit-scrollbar-track{
    background: #fff;
  }
  div::-webkit-scrollbar-thumb{
    background: #B1B1B1;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/questions/answerCard.vue